import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "./hooks/CartContext";
import { useAuth } from "./hooks/AuthProvider";
import "./Header.css";

const Header = () => {
  const {userId,logOut} = useAuth();
  const { cartCount } = useCart();
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/shop?search=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
    navigate("/shop"); // Navigate back to original URL without search param
  };

  const handleLogout=()=>{
        logOut();
    }


  return (
    <>
      <header id="header" className="header-default header-style-2">
        <div className="main-header line">
          <div className="container-full px_15 lg-px_40">
            <div className="row wrapper-header align-items-center">
              <div className="col-xl-2 col-md-4 col-6 tf-md-hidden">
                <Link to="/" className="logo-header">
                  <img src={`${process.env.PUBLIC_URL}/images/logo/GeniusBabyLogo.png`} alt="logo" className="logo" />
                </Link>
              </div>
              <div className="col-xl-8 tf-md-hidden">
                <div className="d-flex justify-content-center align-items-center" style={{ maxHeight: "68px" }}>
                  <nav className="box-navigation text-center">
                    <ul className="box-nav-ul d-flex align-items-center justify-content-center gap-30">
                      <li className="menu-item">
                        <Link to="/" className="item-link">
                          Home
                        </Link>
                      </li>
                      <li className="menu-item">
                        <Link to="/shop" className="item-link">
                          Shop
                        </Link>
                      </li>
                      <li className="menu-item">
                        <Link to="/about" className="item-link">
                          About
                        </Link>
                      </li>
                      <li className="menu-item position-relative">
                        <Link to="/contact" className="item-link">
                          Contact
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div className="col-md-4 col-3 tf-lg-hidden">
                <a href="#mobileMenu" data-bs-toggle="offcanvas" aria-controls="offcanvasLeft">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" fill="none">
                    <path
                      d="M2.00056 2.28571H16.8577C17.1608 2.28571 17.4515 2.16531 17.6658 1.95098C17.8802 1.73665 18.0006 1.44596 18.0006 1.14286C18.0006 0.839753 17.8802 0.549063 17.6658 0.334735C17.4515 0.120408 17.1608 0 16.8577 0H2.00056C1.69745 0 1.40676 0.120408 1.19244 0.334735C0.978109 0.549063 0.857702 0.839753 0.857702 1.14286C0.857702 1.44596 0.978109 1.73665 1.19244 1.95098C1.40676 2.16531 1.69745 2.28571 2.00056 2.28571ZM0.857702 8C0.857702 7.6969 0.978109 7.40621 1.19244 7.19188C1.40676 6.97755 1.69745 6.85714 2.00056 6.85714H22.572C22.8751 6.85714 23.1658 6.97755 23.3801 7.19188C23.5944 7.40621 23.7148 7.6969 23.7148 8C23.7148 8.30311 23.5944 8.59379 23.3801 8.80812C23.1658 9.02245 22.8751 9.14286 22.572 9.14286H2.00056C1.69745 9.14286 1.40676 9.02245 1.19244 8.80812C0.978109 8.59379 0.857702 8.30311 0.857702 8ZM0.857702 14.8571C0.857702 14.554 0.978109 14.2633 1.19244 14.049C1.40676 13.8347 1.69745 13.7143 2.00056 13.7143H12.2863C12.5894 13.7143 12.8801 13.8347 13.0944 14.049C13.3087 14.2633 13.4291 14.554 13.4291 14.8571C13.4291 15.1602 13.3087 15.4509 13.0944 15.6653C12.8801 15.8796 12.5894 16 12.2863 16H2.00056C1.69745 16 1.40676 15.8796 1.19244 15.6653C0.978109 15.4509 0.857702 15.1602 0.857702 14.8571Z"
                      fill="currentColor"></path>
                  </svg>
                </a>
              </div>
              <div className="col-xl-2 col-md-4 col-4 text-center tf-lg-hidden">
                <Link to="/" className="logo-header">
                  <img src={`${process.env.PUBLIC_URL}/images/logo/GeniusBabyLogo.png`} alt="logo" className="logo" />
                </Link>
              </div>
              <div className="col-xl-2 col-md-4 col-5">
                <ul className="nav-icon d-flex justify-content-end align-items-center gap-20">
                  <li className="nav-search">
                    <form onSubmit={handleSearch} className="search-form">
                      <input type="text" placeholder="Search products..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="search-input" />
                      {searchQuery && (
                        <button type="button" onClick={clearSearch} className="clear-search-icon">
                          <i className="icon icon-close"></i>
                        </button>
                      )}
                      <button type="submit" className="nav-icon-item">
                        <i className="icon icon-search"></i>
                      </button>
                    </form>
                  </li>
                  <li className="nav-account">                    
                    {
                      !userId
                        ?
                        <Link to="#login" data-bs-toggle="modal" className="nav-icon-item">
                          <i className="icon icon-account"></i>
                        </Link>
                        :
                        <div className="dropdown">
                          <button className="btn dropdown-toggle" type="button" id="accountMenu" data-bs-toggle="dropdown" aria-expanded="false">
                            <i className="icon icon-account"></i>
                          </button>
                          <ul className="dropdown-menu" aria-labelledby="accountMenu">
                            <li><Link to="/my-account" className="dropdown-item" >Account</Link></li>
                            <li><Link to="/login" className="dropdown-item" onClick={handleLogout} >Logout</Link></li>
                          </ul>
                        </div>
                    }
                  </li>
                  <li className="nav-cart">
                    <Link to="view-cart" className="nav-icon-item">
                      <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="16.5" cy="18.5" r="1.5" />
                        <circle cx="9.5" cy="18.5" r="1.5" />
                        <path d="M18 16H8a1 1 0 0 1-.958-.713L4.256 6H3a1 1 0 0 1 0-2h2a1 1 0 0 1 .958.713L6.344 6H21a1 1 0 0 1 .937 1.352l-3 8A1 1 0 0 1 18 16zm-9.256-2h8.563l2.25-6H6.944z" />
                      </svg>
                      <span className="count-box">{cartCount}</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
